// ! TODO change for journey map requirements

import React, { Component } from "react";
import JourneyMap from "./JourneyMap";

class ParticipantJourneyMap extends Component {

  render() {

    return (
      <JourneyMap key={this.props.index} journeyMap={this.props.journeyMap}/>
    );
  }
}

export default ParticipantJourneyMap;


// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/visualisations/ParticipantJourneyMap.js